var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('portal',{attrs:{"to":"modal"}},_vm._l((_setup.modalStack),function(m){return _c(_setup.registry[m.name],_vm._b({key:m.id,tag:"component",on:{"close":function($event){return _setup.modal.close(m.id)}}},'component',m.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }